import { useState } from 'react';
import { Popover } from 'react-tiny-popover';

import { InvoicePopover } from './components';
import { IInvoiceButtonProps } from './types';

export const InvoiceButton = ({ children }: IInvoiceButtonProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const handleOnClick = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const handleClose = () => {
    setIsPopoverOpen(false);
  };

  return (
    <Popover
      reposition={false}
      isOpen={isPopoverOpen}
      onClickOutside={handleClose}
      content={<InvoicePopover />}
      containerClassName="z-[60]"
    >
      <span className="typography-inline-link-3 text-text-link cursor-pointer" onClick={handleOnClick}>
        {children}
      </span>
    </Popover>
  );
};
